import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function ValidationRequiredIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-validation-required-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.63 10.32l-.83 7.43 7.53-2.1.67 5.1-6.87.48 4.51 6-4.59 2.44-3.15-6.32-2.77 6.28-4.77-2.4 4.46-6-6.82-.52.79-5.05 7.37 2.1-.83-7.43h5.3z"
  })));
}